// src/pages/Moderation/ModerationQueuePage/model/tabToQuery.ts
import { ModerationQueueTab } from './types';

export function tabToQuery(tab?: string): {
  approved: boolean | null;
  on_moderation?: boolean;
} {
  // active: on_moderation=true, approved=null
  // approve: approved=true
  // reject: approved=false
  if (tab === 'approve') return { approved: true };
  if (tab === 'reject') return { approved: false };
  return { approved: null, on_moderation: true };
}

export function normalizeTab(tab?: string): ModerationQueueTab {
  if (tab === 'approve') return 'approve';
  if (tab === 'reject') return 'reject';
  return 'active';
}
